import { FileImageOutlined } from '@ant-design/icons';
import { Image, Tooltip } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

type Props = {
  filename: string;
  previewUrl?: string;
  fullSizeUrl?: string;
};

const Placeholder = styled.span`
  align-items: center;
  border: 1px solid ${({ theme }) => theme.borderColor};
  color: ${({ theme }) => theme.labelColor};
  display: inline-flex;
  height: 34px;
  justify-content: center;
  width: 46px;
`;

export const SkydioMediaPreview = ({ filename, previewUrl, fullSizeUrl }: Props) => {
  const { t } = useTranslation();
  const [failed, setFailed] = useState(false);
  const unavailable = t('inspection.skydio.previewUnavailable', 'Preview unavailable');

  return !previewUrl || failed ? (
    <Tooltip title={unavailable}>
      <Placeholder role="img" aria-label={unavailable}>
        <FileImageOutlined aria-hidden />
      </Placeholder>
    </Tooltip>
  ) : (
    <Image
      alt={filename}
      width={46}
      height={34}
      style={{ objectFit: 'cover' }}
      src={previewUrl}
      preview={{ src: fullSizeUrl ?? previewUrl }}
      onError={() => setFailed(true)}
    />
  );
};
